<template>
  <div>
    <pre>{{ liffInfo }}</pre>
    <pre>{{ token }}</pre>
    <pre>{{ user }}</pre>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState({
        liffInfo: (state) => state.liffMemberCard.liffInfo,
        token: (state) => state.liffMemberCard.token,
        user: (state) => state.liffMemberCard.user,
      }),
    },
  }
</script>
